(function () {
  const bundleSelector = '.gbbMixProductPageWrapperV2';
  const wrapperSelector = '.tw-bundle-display-price';
  const displaySelector = '.tw-bundle-display-price__amount';

  const buttonSelector = '.gbbMixCascadeAddToCartBtn';
  const buttonSeparatorSelector =
    '.gbbMixCascadeAddToCartBtnPriceSeperator';
  const buttonPriceSelector =
    '.gbbMixCascadeAddToCartBtnPrice';

  let currentBundleEl = null;
  let priceObserver = null;
  let updateScheduled = false;

  function getPriceNumber(text) {
    const cleaned = String(text || '').replace(/[^\d.]/g, '');
    return parseFloat(cleaned) || 0;
  }

  function formatPrice(price) {
    return `£${price % 1 === 0 ? price.toFixed(0) : price.toFixed(2)}`;
  }

  function getPricingSettings() {
    const wrapperEl = document.querySelector(wrapperSelector);

    if (!wrapperEl) {
      return {
        minimumPrice: 0,
        priceMode: 'dynamic_minimum'
      };
    }

    return {
      minimumPrice:
        parseFloat(wrapperEl.dataset.bundleMinimumPrice) || 0,

      priceMode:
        wrapperEl.dataset.bundlePriceMode || 'dynamic_minimum'
    };
  }

  function getFinalPrice(bundleEl) {
    const settings = getPricingSettings();

    if (settings.priceMode === 'fixed') {
      return settings.minimumPrice;
    }

    const nativePrice = getPriceNumber(
      bundleEl.getAttribute('cart-total-price')
    );

    return Math.max(nativePrice, settings.minimumPrice);
  }

  function updatePrices(bundleEl) {
    if (!bundleEl || !document.contains(bundleEl)) {
      return;
    }

    const finalPrice = getFinalPrice(bundleEl);
    const formattedPrice = formatPrice(finalPrice);

    // Main PDP price beneath the product title.
    const displayPriceEl = document.querySelector(displaySelector);

    if (
      displayPriceEl &&
      displayPriceEl.textContent !== formattedPrice
    ) {
      displayPriceEl.textContent = formattedPrice;
    }

    // Easy Bundle add-to-cart button price.
    const separatorEl = bundleEl.querySelector(
      buttonSeparatorSelector
    );

    const buttonPriceEl = bundleEl.querySelector(
      buttonPriceSelector
    );

    if (
      separatorEl &&
      separatorEl.textContent !== '·'
    ) {
      separatorEl.textContent = '·';
    }

    if (
      buttonPriceEl &&
      buttonPriceEl.textContent !== formattedPrice
    ) {
      buttonPriceEl.textContent = formattedPrice;
    }
  }

  function scheduleUpdate() {
    if (updateScheduled) {
      return;
    }

    updateScheduled = true;

    requestAnimationFrame(function () {
      updateScheduled = false;

      const bundleEl = document.querySelector(bundleSelector);

      if (!bundleEl) {
        return;
      }

      if (bundleEl !== currentBundleEl) {
        attachPriceObserver(bundleEl);
      }

      updatePrices(bundleEl);
    });
  }

  function attachPriceObserver(bundleEl) {
    if (priceObserver) {
      priceObserver.disconnect();
    }

    currentBundleEl = bundleEl;

    priceObserver = new MutationObserver(function (mutations) {
      const priceChanged = mutations.some(function (mutation) {
        return (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'cart-total-price'
        );
      });

      if (priceChanged) {
        scheduleUpdate();
      }
    });

    priceObserver.observe(bundleEl, {
      attributes: true,
      attributeFilter: ['cart-total-price']
    });

    updatePrices(bundleEl);
  }

  function nodeContainsRelevantElement(node) {
    if (!(node instanceof Element)) {
      return false;
    }

    return (
      node.matches(bundleSelector) ||
      node.matches(buttonSelector) ||
      node.querySelector(bundleSelector) !== null ||
      node.querySelector(buttonSelector) !== null
    );
  }

  function init() {
    const bundleEl = document.querySelector(bundleSelector);

    if (bundleEl) {
      attachPriceObserver(bundleEl);
    }

    /*
     * Easy Bundle may replace its button or entire widget after
     * adding the bundle to the cart. This observer only reacts
     * when a relevant Easy Bundle element is inserted.
     */
    const structureObserver = new MutationObserver(function (mutations) {
      const relevantElementAdded = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(
          nodeContainsRelevantElement
        );
      });

      if (relevantElementAdded) {
        scheduleUpdate();
      }
    });

    structureObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    /*
     * Easy Bundle also emits this event when its cart data changes.
     * The slight delay allows its refreshed button markup to render.
     */
    document.addEventListener(
      'gbbMix-cartData-update',
      function () {
        setTimeout(scheduleUpdate, 50);
      }
    );

    if (!bundleEl) {
      scheduleUpdate();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();